import React, { useContext, useEffect, useMemo, useState } from "react";
import ContainerComponent from "../../../components/Container/ContainerComponent";
import TypographyComponent from "../../../components/Typography/ThypographyComponent";
import BoxComponent from "../../../components/Box/BoxComponent";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import SvgComponent from "../../../components/Image/SvgComponent";
import { ReactComponent as PerfilIcon } from "../../../assets/icons/perfil.svg";
import { ReactComponent as TelefoneIcon } from "../../../assets/icons/telefone.svg";
import { ReactComponent as SairIcon } from "../../../assets/icons/sair.svg";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import { ReactComponent as LixeiraIcon } from "../../../assets/icons/lixeira.svg";
import { AuthContext } from "../../../provider/auth/AuthContext";
import FormComponent from "../../../components/form/FormComponent";
import { LoginDTO, Usuario, UsuarioEnderecos } from "../../../provider/auth/AuthProps";
import LabelComponent from "../../../components/Label/LabelComponent";
import TextFieldComponent from "../../../components/TextField/TextFieldComponent";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";
import { usuarioService } from "../../../service/UsuarioService";

export const sectionStyle = {
    display: "flex",
    flexDireection: "column",
    alignItems: "center",
    justifyContent: "space-between",

    backgroundColor: 'rgba(255, 255, 255, 0.01)',

    boxShadow: `
      0px 2px 4px -2px rgba(0, 0, 0, 0.10), 
      0px 4px 6px -1px rgba(0, 0, 0, 0.10)
    `,

    border: '1px solid rgba(232, 223, 213, 0.2)',

    borderRadius: '8px',
    padding: '16px',
    backdropFilter: 'blur(4px)',
    gap: 2
};

export const labelStyle = {
    fontFamily: '"Font 1", sans-serif',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0%',
    color: '#101828',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle'
};

export const inputStyle = {
    width: '384px',
    padding: 0,
    '& .MuiOutlinedInput-root': {
        height: '48.86px',
        borderRadius: '10.4px',
        border: '1px solid #E5E7EB',
    },
    '& .MuiInputBase-input': {
        // Aqui aplicamos seus paddings exatos
        paddingTop: '13.13px',
        paddingRight: '16.07px',
        paddingBottom: '14.73px',
        paddingLeft: '16.07px',
        height: '48.86px',
        boxSizing: 'border-box',
        fontFamily: '"Font 1", sans-serif',
        fontSize: '14px',
    }
};

const CatalogoPerfilPage = () => {
    const {
        loginCliente,
        logoutCliente,
        cliente
    } = useContext(AuthContext);

    const navigate = useNavigate();

    const [loginUser, setLoginUser] = useState<LoginDTO>({
        login: "",
        senha: ""
    });

    const [isTelefone, setIsTelefone] = useState<boolean>(false);

    const handleClickSair = () => {
        logoutCliente();
        setEnderecos([]);
    }

    const handleClickAddEndereco = () => {
        alert("adicionar endereco");
    }

    const handleClickDeletarEndereco = (id: number) => {
        alert("deletar endereco no index: " + id);
    }

    const handleChangeLogin = (login: string) => {
        const isTelefone = login.length == 11 && !login.includes("@");

        setIsTelefone(isTelefone);

        setLoginUser({
            ...loginUser,
            login: login
        });
    }

    const handleLoginUser = async (event: any) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append("login", loginUser.login);
        //formData.append("senha", data.senha);        

        try {
            const usuario = await loginCliente(loginUser); 
            
            /*
            const enderecosCliente = usuarioService.getEnderecosPorTelefoneLocalStorage(usuario.telefoneCompleto);

            if (enderecosCliente !== null) setEnderecos(enderecosCliente);
            */            
        } catch (err: any) {
            if (err.message) alert(err.message);
            else alert("Falha durante login.");
        }
    }

    const [enderecos, setEnderecos] = useState<UsuarioEnderecos[]>();

    useEffect(() => {
        if (cliente !== null) {
            const enderecosCliente = usuarioService.getEnderecosPorTelefoneLocalStorage(cliente.telefoneCompleto);
            if (enderecosCliente !== null) setEnderecos(enderecosCliente);
        }
    }, []);

    useEffect(() => {
        if (cliente !== null) {
            const enderecosCliente = usuarioService.getEnderecosPorTelefoneLocalStorage(cliente.telefoneCompleto);
            if (enderecosCliente !== null) setEnderecos(enderecosCliente);
        }
    }, [cliente]);

    const renderEnderecos = () => {
        if (enderecos === null || enderecos?.length === 0) return <TypographyComponent
            variant="h5"
            sx={{
                fontFamily: '"Font 1", sans-serif',
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '24px',
                letterSpacing: '0%',
                color: '#101828',
                display: 'inline-flex',
                alignItems: 'center',
                verticalAlign: 'middle'
            }}
        >
            Nenhum endereço cadastrado.
        </TypographyComponent>

        return <>
            {enderecos?.map((element: UsuarioEnderecos, index: number) => {
                return <BoxComponent component="article"
                    key={`endereco-${index}`}
                    sx={{
                        width: '100%',
                        //height: '154.13px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        gap: '-0.01px',
                        opacity: 1,
                        padding: '16.07px',
                        borderRadius: '10.4px',
                        backgroundColor: '#F9FAFB',
                        borderTop: '1px solid #E5E7EB',
                        boxSizing: 'border-box'
                    }}>

                    <BoxComponent component="div" sx={{
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        <TypographyComponent
                            variant="h5"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '24px',
                                letterSpacing: '0%',
                                color: '#101828',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            {element.nome}
                        </TypographyComponent>
                        <TypographyComponent
                            variant="body2"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 400,
                                fontSize: '14px',
                                lineHeight: '20px',
                                letterSpacing: '0%',
                                color: '#4A5565',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            {element.enderecoCompleto}
                        </TypographyComponent>
                        {/* <TypographyComponent
                        variant="body2"
                        sx={{
                            fontFamily: '"Font 1", sans-serif',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                            color: '#4A5565',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle'
                        }}
                    >
                        dd, dd
                    </TypographyComponent>
                    <TypographyComponent
                        variant="body2"
                        sx={{
                            fontFamily: '"Font 1", sans-serif',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                            color: '#4A5565',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle'
                        }}
                    >
                        dd, dd
                    </TypographyComponent>
                    <TypographyComponent
                        variant="body2"
                        sx={{
                            fontFamily: '"Font 1", sans-serif',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                            color: '#4A5565',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle'
                        }}
                    >
                        dd, dd
                    </TypographyComponent> */}

                    </BoxComponent>
                    <ButtonComponent id="botao-add-endereco"
                        sx={{
                            fontFamily: '"Font 1", sans-serif',
                            fontWeight: 600,
                            fontSize: '16px',
                            lineHeight: '24px',
                            letterSpacing: '0%',
                            textAlign: 'center',
                            verticalAlign: 'middle',
                            color: '#FFFFFF',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textTransform: 'none',
                            borderRadius: "10.4px",
                            height: 20,
                            width: 20,
                            minWidth: 20,
                            maxWidth: 20,
                            gap: 1
                        }}
                        onClick={() => handleClickDeletarEndereco(index)}
                    >
                        <SvgComponent
                            icon={<LixeiraIcon />}
                            sx={{
                                display: "flex",
                                alignpropss: "center",
                                justifyContent: "center",
                                width: 18,
                                height: 18,
                                "& svg, & svg *": {
                                    stroke: "#E7000B",
                                },
                            }}
                        />
                    </ButtonComponent>
                </BoxComponent>
            })}
        </>
    }

    return <ContainerComponent
        component="section"
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            textAlign: "center",
            gap: 2,
            pt: 2,
            //mt: -6
            height: "100%"
        }}
    >
        <TypographyComponent
            variant="h1"
            sx={{
                fontFamily: '"Font 2", sans-serif',
                fontWeight: 700,
                fontSize: '30px',
                lineHeight: '36px',
                letterSpacing: '0%',
                color: '#101828',
                display: 'flex',
                alignItems: 'center',
                opacity: 1,
            }}
        >
            Meu Perfil
        </TypographyComponent>

        {cliente && (
            <>
                <BoxComponent
                    component="div"
                    sx={sectionStyle}
                >
                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "1rem"
                        }}
                    >
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: 64,
                                width: 64,
                                borderRadius: "50%",
                                background: "#FFE2E2"
                            }}
                        >
                            <SvgComponent
                                icon={<PerfilIcon />}
                                sx={{
                                    display: "flex",
                                    alignpropss: "center",
                                    justifyContent: "center",
                                    width: 32,
                                    height: 32,
                                    "& svg, & svg *": {
                                        stroke: "#EF4444",
                                    },
                                }}
                            />
                        </BoxComponent>
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            <TypographyComponent
                                variant="h2"
                                sx={{
                                    fontFamily: '"Font 2", sans-serif',
                                    fontWeight: 700,
                                    fontSize: '24px',
                                    lineHeight: '32px',
                                    letterSpacing: '0%',
                                    color: '#101828',
                                    display: 'flex',
                                    alignItems: 'center',
                                    verticalAlign: 'middle',
                                    opacity: 1,
                                }}
                            >
                                {cliente.nome}
                            </TypographyComponent>

                            <BoxComponent component="div" sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                <SvgComponent
                                    icon={<TelefoneIcon />}
                                    sx={{
                                        display: "flex",
                                        alignpropss: "center",
                                        justifyContent: "center",
                                        width: 14,
                                        height: 14,
                                        "& svg, & svg *": {
                                            stroke: "#4A5565",
                                        },
                                    }}
                                />

                                <TypographyComponent
                                    variant="body2"
                                    sx={{
                                        fontFamily: '"Font 1", sans-serif',
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '24px',
                                        letterSpacing: '0em',
                                        color: '#4A5565',
                                        display: 'flex',
                                        alignItems: 'center',
                                        verticalAlign: 'middle',
                                        gap: 1
                                    }}
                                >

                                    {cliente.telefoneCompleto}
                                </TypographyComponent>
                            </BoxComponent>
                        </BoxComponent>
                    </BoxComponent>

                    <BoxComponent component="div" sx={{ display: "flex", gap: 1.5 }}>
                        <ButtonComponent
                            id="botao-sair"
                            sx={{
                                width: 88,
                                height: 40,
                                borderRadius: '10.4px',
                                backgroundColor: '#F3F4F6',
                                color: '#4A5565',

                                boxShadow: 'none',
                                textTransform: 'none',
                                minWidth: 0,

                                '&:hover': {
                                    backgroundColor: '#E5E7EB',
                                    boxShadow: 'none',
                                },

                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 500,
                                fontSize: '14px',
                                gap: 1
                            }}
                            onClick={handleClickSair}
                        >
                            <SvgComponent
                                icon={<SairIcon />}
                                sx={{
                                    display: "flex",
                                    alignpropss: "center",
                                    justifyContent: "center",
                                    width: 14,
                                    height: 14,
                                    "& svg, & svg *": {
                                        stroke: "#4A5565",
                                    },
                                }}
                            />
                            Sair
                        </ButtonComponent>
                    </BoxComponent>
                </BoxComponent>

                <BoxComponent
                    component="div"
                    sx={{ ...sectionStyle, flexDirection: "column" }}
                >
                    <BoxComponent component="div" sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%"
                    }}>
                        <TypographyComponent
                            variant="h3"
                            sx={{
                                fontFamily: '"Font 2", sans-serif',
                                fontWeight: 700,
                                fontSize: '20px',
                                lineHeight: '28px',
                                letterSpacing: '0%',
                                color: '#101828',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            Meus endereços
                        </TypographyComponent>

                        <ButtonComponent id="botao-add-endereco"
                            sx={{
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '24px',
                                letterSpacing: '0%',
                                textAlign: 'center',
                                verticalAlign: 'middle',
                                backgroundColor: '#E7000B',
                                color: '#FFFFFF',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                textTransform: 'none',
                                borderRadius: "10.4px",
                                height: 40,
                                width: 175,
                                gap: 1
                            }}
                            onClick={handleClickAddEndereco}
                        >
                            <SvgComponent
                                icon={<PlusIcon />}
                                sx={{
                                    display: "flex",
                                    alignpropss: "center",
                                    justifyContent: "center",
                                    width: 18,
                                    height: 18,
                                    "& svg, & svg *": {
                                        stroke: "#FFFFFF",
                                    },
                                }}
                            />
                            Novo endereço
                        </ButtonComponent>
                    </BoxComponent>

                    {/* ENDERECOS DO CLIENTE */}
                    <BoxComponent component="div" sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%"
                    }}>
                        {renderEnderecos()}
                    </BoxComponent>
                </BoxComponent>
            </>
        )}

        {cliente == null && (
            <>
                <BoxComponent
                    component="div"
                    sx={{
                        ...sectionStyle,
                        justifyContent: "center",
                        boxShadow: '',
                        height: "100%"
                    }}
                >
                    <FormComponent
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyItems: "center",
                            alignItems: "center",
                            //width: "50%",
                            gap: 2,
                            //p: 1.5,
                            border: '',
                            width: 448,
                            borderRadius: "14.4px",
                            backgroundColor: 'rgba(255, 255, 255, 0.01)',
                            boxShadow: `
                                0px 2px 4px -2px rgba(0, 0, 0, 0.10), 
                                0px 4px 6px -1px rgba(0, 0, 0, 0.10)
                                `,
                            opacity: 1,
                            //height: 300
                            py: 3
                        }}
                        onSubmit={(e: any) => handleLoginUser(e)}
                    >
                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 1.5
                            }}
                        >
                            <SvgComponent
                                icon={<PerfilIcon />}
                                sx={{
                                    display: "flex",
                                    alignpropss: "center",
                                    justifyContent: "center",
                                    width: 48,
                                    height: 48,
                                    "& svg, & svg *": {
                                        stroke: "#D1D5DC",
                                    },
                                }}
                            />
                            <TypographyComponent
                                variant="body2"
                                sx={{
                                    fontFamily: '"Font 1", sans-serif',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    letterSpacing: '0%',
                                    textAlign: 'center',
                                    verticalAlign: 'middle',
                                    color: '#4A5565',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                Faça login para acessar seu perfil
                            </TypographyComponent>
                        </BoxComponent>

                        <BoxComponent
                            component="div"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                        >
                            <BoxComponent
                                component="fieldset"
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    border: "0px"
                                }}
                            >
                                <LabelComponent htmlFor="telefone" sx={labelStyle}>Login</LabelComponent>
                                <TextFieldComponent
                                    id="login"
                                    value={loginUser.login}
                                    onChange={(e: any) => handleChangeLogin(e.target.value)}
                                    required
                                    maskTelefone={isTelefone}
                                    sx={inputStyle}
                                    variant="outlined"
                                    disableUnderline
                                />
                            </BoxComponent>
                        </BoxComponent>
                        <ButtonComponent
                            id="botao-login"
                            type="submit"
                            sx={{
                                width: "384px",
                                borderRadius: "10.4px",
                                background: "#E7000B",
                                color: "#FFFFFF",
                                fontFamily: '"Font 1", sans-serif',
                                fontWeight: 700,
                                fontSize: '16px',
                                lineHeight: '24px', // Mapeando s+
                                letterSpacing: '0%',
                                textAlign: 'center',
                                verticalAlign: 'middle',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: 1,
                                textTransform: "none"
                            }}
                        >
                            Entrar
                        </ButtonComponent>

                    </FormComponent>
                </BoxComponent>
            </>
        )}

    </ContainerComponent>
}

export default CatalogoPerfilPage;